import React from 'react';

import logo from '../../assets/images/SoleraLogo_TW.png';

import config from '../../config/config.json';

import './Footer.scss';

function Footer({text}) {

  const auth = text;

  return (
    <footer id="pageFooter" className="footer">
    <div className={auth ? 'short-footer-container' : 'full-footer-container'}>
        <div className="useful-links">
          <p id="usefulLinksTitle" className="raleway-bold">Useful Links</p>
          <p><a id="helpLink" href={config.helpAndFAQsUrl} target="_blank" rel="noreferrer">Help &amp; FAQ</a></p>
          <p><a id="termsLink" href={config.termsAndConditionsUrl} target="_blank" rel="noreferrer">Terms &amp; Conditions</a></p>
          <p><a id="privacyLink" href={config.privacyPolicyUrl} target="_blank" rel="noreferrer">Privacy Policy</a></p>
        </div>
        <div className="caphpi-links">
          <p id="caphpiTitle" className="raleway-bold">cap hpi</p>
          <p><a id="aboutLink" href={config.capHpiAboutUrl} target="_blank" rel="noreferrer">About</a></p>
          <p><a id="extrasLink" href={config.capHpiExtrasUrl} target="_blank" rel="noreferrer">Extras</a></p>
        </div>
        <div className="footer-logo">
          <img src={logo} alt=""></img>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
